import * as React from "react"
import { SaTitle } from "../saTitle/saTitle"
// @ts-ignore
import {    btnNext,    btnPrev,    saTestimonialsList,    saTestimonialsListItem,    saTestimonialsListItemContent,    saTestimonialsListItemContentContainer,    saTestimonialsListItemImageContainer,    saTestimonialsListItemName,    saTestimonialsListItemPosition,    saTestimonialsSlider} from "./saTestimonials.module.scss"
import SaImage from "../saImage/saImage"
import { saInterfaceTestimonial } from "../saTypes"

import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import SaIcons from "../saIcons/saIcons"


class SaTestimonialsList extends React.Component<Array<saInterfaceTestimonial>> {

    private slider: typeof Slider | null; // <---- improved this type
    private setRef: (element: typeof Slider | null) => void; // <---- added this


    constructor(props) {
        super(props);

        this.slider = null;
        this.setRef = element => {
            this.slider = element;
        };
        this.play = this.play.bind(this);
        this.pause = this.pause.bind(this);
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
    }

    play() {
        this.slider.slickPlay();
    }
    pause() {
        this.slider.slickPause();
    }
    next() {
        this.slider.slickPause();
        this.slider.slickNext();
        setTimeout(() => this.slider.slickPlay(), 10000);
    }
    previous() {
        this.slider.slickPause();
        this.slider.slickPrev();
        setTimeout(() => this.slider.slickPlay(), 10000);
    }

    render() {

        let posts = this.props

        const saSettings: any = {
            autoplay: true,
            arrows: false,
            autoplaySpeed: 3000,
            infinite: true,
            slidesToShow: 1,
            speed: 1000,
            fade: true,
            cssEase: "linear"
        }

        let testimonialsList = Object.values(posts).map((item , index) => (
            <div key={index} className={saTestimonialsListItem}>

                {
                    item.testimonialsPosts.details.image &&
                    <div className={saTestimonialsListItemImageContainer}>
                        <SaImage {...item.testimonialsPosts.details.image} />
                    </div>
                }

                {
                    item.content &&
                    <div className={saTestimonialsListItemContentContainer}>
                        <SaTitle title={item.content} classes={saTestimonialsListItemContent} />
                    </div>
                }

                {
                    item.title &&
                    <div className={saTestimonialsListItemName}
                         dangerouslySetInnerHTML={{ __html: item.title }} />
                }

                {
                    item.testimonialsPosts.details.position &&
                    <div className={saTestimonialsListItemPosition}
                         dangerouslySetInnerHTML={{ __html: item.testimonialsPosts.details.position }} />
                }

            </div>
          )
        )

        return (
          <div className={saTestimonialsList}>

              <div className={btnPrev} onClick={this.previous}>
                  <SaIcons name={'leftArrow'} />
              </div>

              <div className={saTestimonialsSlider}>
                  <Slider ref={c => (this.slider = c)} {...saSettings}>
                      {testimonialsList}
                  </Slider>
              </div>

              <div className={btnNext}  onClick={this.next}>
                  <SaIcons name={'rightArrow'} />
              </div>

          </div>
        )

    }
}

export default SaTestimonialsList